/*
 * @Author: 孙照
 * @LastEditTime: 2023-02-01 16:37:18
 * @Description: vuex 常量
 * @FilePath: \dsnd_monitor\src\store\const\index.js
 */

// 单电站充电情况弹框 开关
export const STATION_MODAL_CHANGE = 'stationModalChange';
// 光伏弹框 开关
export const STATION_PV_MODAL_CHARGE = 'stationPvModalCharge';
// 储能统计弹框 开关
export const STATION_ENERGY_STORAGE_CHARGE = 'stationEnergyStorageCharge';
